import { useState } from "react";
import { createTss } from "tss-react";
import { Theme } from "./theme/types";
import { darkTheme } from "./theme/dark";

const useContext = () => {
    const [theme] = useState<Theme>(darkTheme);
    return {theme}
}

export const { tss } = createTss({useContext})